<template>
  <div class="input-select d-block" v-on-clickaway="closeSelect">
    <label @click="closeSelect">{{ $t(label) }}</label>
    <div
      @click="openListOnClick"
      class="input-like"
      :class="{disabled : disabled}"
      tabindex="0"
      @focus="openListOnFocus">
      <span v-if="cmpTextValue === ''">Select</span>
      <span v-else class="cut-text">{{ cmpTextValue }}</span>
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <div v-show="isListOpened" class="options-list">
      <input
        ref="searchField"
        class="search"
        @keydown="searchIt"
        v-model="search"
        :placeholder="$t('Search...')" />
      <ul>
        <li
          @keydown.prevent="nextItem"
          tabIndex="-1"
          v-for="(item, index) in filteredList"
          :ref="`${randomSelectId}-${index}-opt`"
          :key="`option-${index}`"
          :class="{active: indexItem === index}"
          @click="changeValue(index, item)">
          {{ `${item.name} (${item.alpha2})` }}
          <input :value="item.alpha2" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import stateList from '@/data/state.js';

export default {
  name: 'StateSelect',
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: 'state',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: '',
    },
    countryId: {
      type: [Number, String],
      default: '',
    }
  },
  data() {
    return {
      indexItem: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
    };
  },
  computed: {
    stateListComputed() {
      return stateList.filter(state => {
        if(parseInt(state.country_id) === parseInt(this.countryId)){
          return state;
        }
      });
    },
    filteredList() {
      const stateFilteredList = stateList.filter(state => {
        if(parseInt(state.country_id) === parseInt(this.countryId)){
          return state;
        }
      });
      return stateFilteredList.filter(state => {
        const term = `${state.name} ${state.alpha2}`;
        return term.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    cmpTextValue() {
      if(this.value === null || this.value === undefined) return '';
      if( this.value !== '' ) {
        this.filteredList.filter((state, index) => {
          if(state.alpha2 == this.value) this.indexItem = index;
        });
      }
      //console.log(this.value, this.stateListComputed)
      const states = this.value !== '' ? this.stateListComputed.filter(state => state.alpha2 == this.value) : '';

      return states.length ? states[0].name : '';
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
  },
  methods: {
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.nextItem(event);
      } else {
        this.indexItem = 0;
        this.search = event.target.value;
      }
    },
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.filteredList.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    changeValue(index, option) {
      this.indexItem = index;
      this.isListOpened = false;
      this.openedOnClick = false;
      this.$emit('change', option.alpha2);
      this.$emit('input', option.alpha2);
      this.search = '';
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    openListOnClick() {
      if (this.disabled) {
        return;
      }
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
    openListOnFocus() {
      if (this.disabled) {
        return;
      }
      this.isListOpened = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        this.$refs.searchField.focus();
      });
    },
  },
}
</script>
